// Vendors
import React from 'react';
import { render } from 'react-dom';

// Components
import { DynamicModal, PageViewModal } from './apps/components';

const ModalsApp = () => (
  <>
    <DynamicModal />
    <PageViewModal />
  </>
);

// Render ModalsApp
const modalsAppRoot = document.getElementById('app-modals');
if (modalsAppRoot) render(<ModalsApp />, modalsAppRoot);
